/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc
 */

export let ComHubspotUsagebasedbillingExperienceCore;
(function (_ComHubspotUsagebasedbillingExperienceCore) {})(ComHubspotUsagebasedbillingExperienceCore || (ComHubspotUsagebasedbillingExperienceCore = {}));
export let ComHubspotUsagebasedbillingExperienceRpcModels;
(function (_ComHubspotUsagebasedbillingExperienceRpcModels) {})(ComHubspotUsagebasedbillingExperienceRpcModels || (ComHubspotUsagebasedbillingExperienceRpcModels = {}));
export const getUsagePeriodUsageRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getUsagePeriodUsage',
  auth: 'app',
  fingerprint: '9kZhuu7l6isnkq-n2MCZLxUqMzK9s8S2',
  na1Only: false
};
export const getHistoricalByFeatureCategoryRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getHistoricalByFeatureCategory',
  auth: 'app',
  fingerprint: 'dyhuTHx-LUVF1diw-w6m9xUqMzK9s8S2',
  na1Only: false
};
export const getHistoricalByBillableMetricTypeRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getHistoricalByBillableMetricType',
  auth: 'app',
  fingerprint: 'IZToiqr50ASBoIiQLAZ9NxUqMzK9s8S2',
  na1Only: false
};
export const getRateCardRpc = {
  serviceName: 'com.hubspot.usagebasedbilling.experience.rpc.UsageBasedBillingExperienceRpc',
  rpcName: 'getRateCard',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAch7bIS2-iqRUqMzK9s8S2',
  na1Only: false
};